import React, { Component } from "react";
import { useEffect, useState } from "react";

import PropTypes from "prop-types";

// import { Line } from "react-chartjs-2"
import ReactApexChart from "react-apexcharts";

import moment from "moment";

// class LineGraphOffshore extends Component {

const LineGraphOffshore = props => {
  // console.log(props);
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const [series, setSeries] = useState([
    {
      name: "MAX",
      data: [5, 5, 5, 5, 5, 5, 5],
    },
    {
      name: "TSO",
      data: [-6, -4, 2.1, 1, -3, 2.2, 4],
    },
    {
      name: "MIN",
      data: [-5, -5, -5, -5, -5, -5, -5],
    },
  ]);
  const [options, setOptions] = useState({
    chart: { zoom: { enabled: !1 }, toolbar: { show: !1 } },
    colors: ["#FF7F37"],
    // stroke: { width: [3, 3, 3], curve: "straight", dashArray: [8, 0, 8] },

    title: { text: "Percent (%)", align: "left" },
    markers: { size: 0, hover: { sizeOffset: 6 } },

    xaxis: {
      // text: "Date",
      categories: [
        "Date 0",
        "Date 5",
        "Date 10",
        "Date 15",
        "Date 20",
        "Date 25",
        "Date 30",
        "Date 31",
        // "01 Jan",
        // "02 Jan",
        // "03 Jan",
        // "04 Jan",
        // "05 Jan",
        // "06 Jan",
        // "07 Jan",
        // "08 Jan",
        // "09 Jan",
        // "10 Jan",
        // "11 Jan",
        // "12 Jan",
      ],
    },
    tooltip: {
      // y: [
      //   {
      //     title: {
      //       formatter: function (e) {
      //         return e + " (mins)";
      //       },
      //     },
      //   },
      //   {
      //     title: {
      //       formatter: function (e) {
      //         return e + " per session";
      //       },
      //     },
      //   },
      //   {
      //     title: {
      //       formatter: function (e) {
      //         return e;
      //       },
      //     },
      //   },
      // ],
    },
    grid: { borderColor: "#f1f1f1" },
  });

  useEffect(() => {
    renderGraph();
    // console.log(props.data);
  }, [props.data, props.date, props.summaryReportPid]);

  const renderGraph = () => {
    let dataSort = props.data.sort(function (a, b) {
      return moment(a.REPORT_DATE).toDate() - moment(b.REPORT_DATE).toDate();
    });

    // console.log(dataSort);

    let dateList = [moment(props.date).locale("en").format("D MMM YYYY")];
   
    for (let index = 0; index < 29; index++) {
      dateList.unshift(
        moment(props.date)
          .add("days", -(index + 1))
          .locale("en")
          .format("D MMM YYYY")
      );
      
    }
    // console.log(dateList);
    // console.log(dataSort);

    // let dateList = [moment(props.date).locale("en").format("D MMM YYYY")];

    // for (let index = 0; index < 29; index++) {
    //   // maxList.push(min);
    //   // minList.push(max);
    //   dateList.unshift(
    //     moment(props.date)
    //       .add("days", -(index + 1))
    //       .locale("en")
    //       .format("D MMM YYYY")
    //   );

    let dataGraph = [];
    // console.log(props.summaryReportPid);
    dateList.map(item => {
      let data = dataSort.find(row => {
        // console.log(row,item);
        if (item == moment(props.date).locale("en").format("D MMM YYYY")) {
          // console.log("test");
          return (
            moment(row.REPORT_DATE).locale("en").format("D MMM YYYY") == item &&
            props.summaryReportPid == row.SUMMARYREPORT_PID
          );
        }
        return (
          moment(row.REPORT_DATE).locale("en").format("D MMM YYYY") == item
        );
      });

      // console.log(data);
      if (data == undefined) {
        dataGraph.push(null);
      } else {
        dataGraph.push(data?.BALANCING_BALANCE);
      }
    });
    
//     dateList.map(item => {
//       let tempData = props.data.find(obj => {
//         if (item == moment(props.date).locale("en").format("D MMM YYYY")) {
//           // console.log(obj.BALANCECOLUMN_PID == row.PID,moment(obj.REPORT_DATE).locale("en").format("D MMM YYYY") ==
//           // item , props.summaryReportPid ,obj.SUMMARYREPORT_PID);

//           return (
//             obj.BALANCECOLUMN_PID == row.PID &&
//             moment(obj.REPORT_DATE).locale("en").format("D MMM YYYY") ==
//             item &&
//             props.summaryReportPid == obj.SUMMARYREPORT_PID
//           );
//         }

//         return (
//           obj.BALANCECOLUMN_PID == row.PID &&
//           moment(obj.REPORT_DATE).locale("en").format("D MMM YYYY") == item
//         );
//       });

// //  console.log(tempData)

//       if (tempData == undefined) {
//         data.push(null);
//       } else {
//         data.push(tempData?.BALANCING_BALANCE);
//       }
//     });
    

    // console.log(dataGraph);

    // console.log(dataSort,dataSort.map(row=>moment(row.REPORT_DATE).locale("en").format("D MMM YYYY")))
    // setData(prev => ({
    //   ...prev,
    //   labels: dateList,
    //   datasets: [{ ...prev.datasets[0], data: dataGraph }],
    // }));

    // console.log(dataGraph)

    // ของเก่า
    // let data = props.data.sort(function (a, b) {
    //   return moment(a.REPORT_DATE).toDate() - moment(b.REPORT_DATE).toDate();
    // });

    // let DataList = [...data.map(obj => obj.BALANCING_BALANCE)];
    // ของเก่า

    setSeries([
      // {
      //   name: "MAX",
      //   data: maxList,
      // },
      {
        name: "TSO",
        data: dataGraph,
      },
      // {
      //   name: "MIN",
      //   data: minList,
      // },
    ]);

    let color = [];
    let width = 3;
    let widthList = [width, width];
    let dashArray = [];

    // dashArray.unshift(8);
    // dashArray.push(0);
    // console.log(dashArray)
    setOptions({
      chart: { zoom: { enabled: !1 }, toolbar: { show: !1 } },
      colors: ["#FF7F37"],
      dataLabels: { enabled: !1 },
      // stroke: {
      //   width: [3, 3, 3],
      //   curve: "straight",
      //   dashArray: [8, 0, 8],
      // },
      title: { text: "Percent (%)", align: "left" },
      markers: { size: 0, hover: { sizeOffset: 6 } },
      // xaxis: {
      //   // text: "Date",
      //   categories: dateList,
      // },
      xaxis: {
        categories: dateList.map(row => moment(row).locale("en").format("D MMM")),
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            var val = Math.abs(value);
            if (val >= 1000) {
              if (value < 0) {
                val = val * -1;
              }
              val = numberFormat(val / 1000, 2) + " K";
            } else {
              if (value < 0) {
                val = val * -1;
              }
              val = numberFormat(val, 0);
            }

            return val;
          },
        },
      },
      tooltip: {
        // y: [
        //   {
        //     title: {
        //       formatter: function (e) {
        //         return e + " (mins)";
        //       },
        //     },
        //   },
        //   {
        //     title: {
        //       formatter: function (e) {
        //         return e + " per session";
        //       },
        //     },
        //   },
        //   {
        //     title: {
        //       formatter: function (e) {
        //         return e;
        //       },
        //     },
        //   },
        // ],
      },
      grid: { borderColor: "#f1f1f1" },
    });
  };
  return (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height="400"
        className="apex-charts"
      />
    </React.Fragment>
  );

  //   constructor(props) {
  //       console.log(props);
  //       super(props)

  //       this.state = {
  //           series: [
  //             //   {
  //             //       name: "MAX",
  //             //       data: [5, 5, 5, 5, 5, 5, 5,],
  //             //   },
  //               {
  //                   name: "TSO",
  //                   data: [5, 5, 5, 5, 5, 5, 5,],
  //               },

  //             //   {
  //             //       name: "MIN",
  //             //       data: [-5, -5, -5, -5, -5, -5, -5,],
  //             //   },
  //           ],
  //           options: {
  //               chart: { zoom: { enabled: !1 }, toolbar: { show: !1 } },
  //               colors: ["#FF7F37"],//"#FE5555","#FE5555"
  //               dataLabels: { enabled: !1 },
  //               stroke: { width: [3,3,3], curve: "straight", dashArray: [8,0,8] },
  //               title: { text: "Percent (%)", align: "left" },
  //               markers: { size: 0, hover: { sizeOffset: 6 } },
  //               xaxis: {
  //                   // text: "Date",
  //                   categories: [
  //                       "Date 0",
  //                       "Date 5",
  //                       "Date 10",
  //                       "Date 15",
  //                       "Date 20",
  //                       "Date 25",
  //                       "Date 30",
  //                       "Date 31"
  //                       // "01 Jan",
  //                       // "02 Jan",
  //                       // "03 Jan",
  //                       // "04 Jan",
  //                       // "05 Jan",
  //                       // "06 Jan",
  //                       // "07 Jan",
  //                       // "08 Jan",
  //                       // "09 Jan",
  //                       // "10 Jan",
  //                       // "11 Jan",
  //                       // "12 Jan",
  //                   ],
  //               },
  //               tooltip: {
  //                   y: [
  //                       {
  //                           title: {
  //                               formatter: function (e) {
  //                                   return e + " (mins)"
  //                               },
  //                           },
  //                       },
  //                       {
  //                           title: {
  //                               formatter: function (e) {
  //                                   return e + " per session"
  //                               },
  //                           },
  //                       },
  //                       {
  //                           title: {
  //                               formatter: function (e) {
  //                                   return e
  //                               },
  //                           },
  //                       },
  //                   ],
  //               },
  //               grid: { borderColor: "#f1f1f1" },
  //           },
  //       }
  //   }

  //   render() {
  //       return (
  //           <React.Fragment>
  //               <ReactApexChart
  //                   options={this.state.options}
  //                   series={this.state.series}
  //                   type="line"
  //                   height="400"
  //                   className="apex-charts"
  //               />
  //           </React.Fragment>
  //       )
  //   }
};

LineGraphOffshore.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};
export default LineGraphOffshore;
